import { TCommonData, TWidgetProps } from '@libs/types';
import React from 'react';
import { LoadingAnimationView } from './LoadingAnimationView';

export const LoadingAnimation = ({ widget }: TWidgetProps<TCommonData>) => {
    return <LoadingAnimationView uid={widget.uid} margin={widget.options?.margin} />;
};
